import { useQuery } from '@tanstack/react-query';

import {
  getCountries,
  getCountriesWithPlants,
  getCountriesWithPlantsByProduct,
  getCountryProductSummary,
} from '../api';
import { type Country } from '../types';

export const USE_COUNTRY_PLANTS_KEY = 'useCountriesWithPlants';
export const USE_COUNTRY_PRODUCT_SUMMARY_KEY = 'useCountryProductSummary';
export const USE_COUNTRY_PLANTS_BY_PRODUCT_KEY = 'useCountriesWithPlantsByProduct';

export const useCountriesWithPlants = (enabled = true) =>
  useQuery({
    queryKey: [USE_COUNTRY_PLANTS_KEY],
    queryFn: getCountriesWithPlants,
    staleTime: 1000 * 60 * 15,
    enabled,
  });

export const useCountriesWithPlantsByProduct = (idProduct: number, enabled = true) =>
  useQuery({
    queryKey: [USE_COUNTRY_PLANTS_BY_PRODUCT_KEY, idProduct],
    queryFn: async () => await getCountriesWithPlantsByProduct(idProduct),
    staleTime: 1000 * 60 * 15,
    enabled,
  });

export const useCountryProductSummary = (idProduct: number, enabled = true) =>
  useQuery({
    queryKey: [USE_COUNTRY_PRODUCT_SUMMARY_KEY, idProduct],
    queryFn: async () => await getCountryProductSummary(idProduct),
    staleTime: 1000 * 60 * 15,
    enabled,
  });

export const useCountries = (withProducts = false, initialData?: Country[]) =>
  useQuery({
    queryKey: ['countries', withProducts],
    queryFn: async () => await getCountries(withProducts),
    staleTime: 1000 * 60 * 15,
    initialData,
  });
